// extracted by mini-css-extract-plugin
export default {"small":"VerticalSpace_small__5D+Le","normal":"VerticalSpace_normal__PvhjU","large":"VerticalSpace_large__RLJX4"};